import './login.css';
import TextField from '@mui/material/TextField';
import { Button, createTheme, Typography } from '@mui/material';
import { useState, useContext,useEffect } from 'react';
import IconButton from '@mui/material/IconButton';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { useNavigate } from 'react-router-dom';
import { Grid } from '@mui/material';
import { Box } from '@mui/system';
import useStyle from './login-style';
import { SignInContext } from '../../contexts/signIn';
import ErrorIcon from '@mui/icons-material/Error';
import CheckIcon from '@mui/icons-material/Check';
// import Nav from '../navBar/nav';
import jwt from 'jwt-decode';
const emailvalidator = require("email-validator");
const theme = createTheme({
    typography: {
        fontFamily: '"Segoe UI Symbol"',
    }
})



const Login = () => {
    const signInContext = useContext(SignInContext);
    const navigate = useNavigate();
    useEffect(() => {
        let token = localStorage.getItem("auth-token");
        console.log("token",token);
        if (token === null) {
          return
        }
        else if (token) {
          const user = jwt(token);
           if (user.admin || user.userType == 3 ) {
            navigate('/CCFiles')
          }else if(user.userType == 2 ){
            navigate('/BasicCard')
          }
          else {
            navigate('/chosetype')
          }
        }
        const config = {
          headers: { Authorization: `Bearer ${token}` }
        };
        const bodyParameters = {
          key: "value"
        };
        console.log(token);
        // Axios.post('/isValid', bodyParameters, config).then(result => {
        //   console.log(result);
        //   if (result.data.token === false) {
        //     localStorage.setItem("auth-token", "");
        //     setToken(false);
        //   }
    
        // })
      }, []);
    
    ///Email validate
    const emailVali = () => {
        if (signInContext.email !== "" && !(emailvalidator.validate(signInContext.email))) {
            return (<div className='errorMessage1 emailMsg1'><ErrorIcon sx={{ height: 17 }}></ErrorIcon> <span className='msg1' style={{ position: 'absolute' }}> Incorrect Email</span></div>)
        }
        else if (signInContext.email === "") {
            return
        }
        else {
            return (<div className='passMessage1 emailMsg1'><CheckIcon sx={{ height: 17 }}></CheckIcon><span className='msg1' style={{ position: 'absolute' }}> Correct Email</span> </div>)
        }
    }

    /// Password Validate
    const passwordValidate = () => {
        if (signInContext.password === "") {
            return
        }
        else if (signInContext.password.length < 8) {
            return (<div className='errorMessage'><ErrorIcon sx={{ height: 17 }}></ErrorIcon> <span style={{ position: 'absolute' }}> Your password must be at least 8 characters</span></div>)
        }

        else {
            return (<div className='passMessage'><CheckIcon sx={{ height: 17 }} /> <span style={{ position: 'absolute' }}> Correct  Password</span></div>)
        }
    }


    const sign = async (e) => {
        signInContext.login()
        e.preventDefault();

    };

    const [values, setValues] = useState({ password: '' });

    const handleChange = (prop) => (event) => {
        setValues({ ...values, [prop]: event.target.value });
    };

    const handleClickShowPassword = () => {
        setValues({
            ...values,
            showPassword: !values.showPassword,
        });

    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };


    const redirect = () => {
        navigate('/signUp')
    }
    const forget = () => {
        navigate('/forget-email');
    };
    const classes = useStyle();

     return(
         <>
          <Box
            sx={{
              minHeight: '100vh',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: 'linear-gradient(135deg, #86C85D 0%, #6ba542 100%)',
              padding: 2
            }}
          >
            <Box
              sx={{
                width: '100%',
                maxWidth: '450px',
                bgcolor: 'white',
                borderRadius: 4,
                boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
                p: { xs: 3, sm: 5 },
                position: 'relative',
                overflow: 'hidden',
                '&::before': {
                  content: '""',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  height: '5px',
                  background: 'linear-gradient(90deg, #86C85D 0%, #6ba542 100%)'
                }
              }}
            >
              <form onSubmit={sign}>
                <Box>
                  {/* Logo or Title */}
                  <Box sx={{ textAlign: 'center', mb: 4 }}>
                    <Typography 
                      variant='h4' 
                      sx={{
                        fontWeight: 700,
                        color: '#1a202c',
                        mb: 1,
                        fontSize: { xs: '1.75rem', sm: '2.125rem' }
                      }}
                    >
                      Welcome Back
                    </Typography>
                    <Typography 
                      variant='body2' 
                      sx={{ 
                        color: '#718096',
                        fontSize: '0.938rem'
                      }}
                    >
                      Sign in to continue to Circle Connect
                    </Typography>
                  </Box>

                  <Grid container spacing={3}>
                    {/* Email Field */}
                    <Grid item xs={12}>
                      <TextField 
                        fullWidth
                        label="Email Address" 
                        variant="outlined"
                        type="email"
                        onChange={(e) => {
                          signInContext.setEmail(e.target.value.toLowerCase());
                        }}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: 2,
                            '&:hover fieldset': {
                              borderColor: '#86C85D',
                            },
                            '&.Mui-focused fieldset': {
                              borderColor: '#86C85D',
                              borderWidth: 2
                            }
                          },
                          '& .MuiInputLabel-root.Mui-focused': {
                            color: '#86C85D'
                          }
                        }}
                      />
                      {emailVali()}
                    </Grid>

                    {/* Password Field */}
                    <Grid item xs={12}>
                      <FormControl fullWidth variant="outlined">
                        <InputLabel 
                          htmlFor="outlined-adornment-password"
                          sx={{
                            '&.Mui-focused': {
                              color: '#86C85D'
                            }
                          }}
                        >
                          Password
                        </InputLabel>
                        <OutlinedInput
                          id="outlined-adornment-password"
                          type={values.showPassword ? 'text' : 'password'}
                          onChange={(e) => {
                            signInContext.setPassword(e.target.value);
                          }}
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                                edge="end"
                                sx={{
                                  color: '#86C85D'
                                }}
                              >
                                {values.showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                              </IconButton>
                            </InputAdornment>
                          }
                          label="Password"
                          sx={{
                            borderRadius: 2,
                            '&:hover .MuiOutlinedInput-notchedOutline': {
                              borderColor: '#86C85D',
                            },
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                              borderColor: '#86C85D',
                              borderWidth: 2
                            }
                          }}
                        />
                      </FormControl>
                      {passwordValidate()}
                    </Grid>

                    {/* Login Button */}
                    <Grid item xs={12}>
                      <Button 
                        fullWidth
                        variant='contained'
                        size="large"
                        type='submit'
                        onClick={sign}
                        sx={{
                          bgcolor: '#86C85D',
                          color: 'white',
                          py: 1.5,
                          borderRadius: 2,
                          fontSize: '1rem',
                          fontWeight: 600,
                          textTransform: 'none',
                          boxShadow: '0 4px 12px rgba(134, 200, 93, 0.4)',
                          transition: 'all 0.3s ease',
                          '&:hover': {
                            bgcolor: '#6ba542',
                            boxShadow: '0 6px 16px rgba(134, 200, 93, 0.6)',
                            transform: 'translateY(-2px)'
                          },
                          '&:active': {
                            transform: 'translateY(0)'
                          }
                        }}
                      >
                        Sign In
                      </Button>
                    </Grid>
                  </Grid>

                  {/* Error/Success Message */}
                  {signInContext.message && (
                    <Box 
                      sx={{ 
                        mt: 3,
                        p: 2,
                        bgcolor: signInContext.message.includes('success') ? '#f0fdf4' : '#fef2f2',
                        border: '1px solid',
                        borderColor: signInContext.message.includes('success') ? '#86efac' : '#fca5a5',
                        borderRadius: 2,
                        color: signInContext.message.includes('success') ? '#166534' : '#991b1b',
                        fontSize: '0.875rem',
                        textAlign: 'center'
                      }}
                    >
                      {signInContext.message}
                    </Box>
                  )}

                  {/* Footer Links */}
                  <Box sx={{ mt: 4, textAlign: 'center' }}>
                    <Typography 
                      variant="body2" 
                      sx={{ 
                        color: '#718096',
                        fontSize: '0.875rem'
                      }}
                    >
                      Don't have an account?{' '}
                      <Typography
                        component="span"
                        onClick={redirect}
                        sx={{
                          color: '#86C85D',
                          fontWeight: 600,
                          cursor: 'pointer',
                          textDecoration: 'none',
                          '&:hover': {
                            textDecoration: 'underline'
                          }
                        }}
                      >
                        Sign Up
                      </Typography>
                    </Typography>
                    <Typography
                      variant="body2"
                      onClick={forget}
                      sx={{
                        color: '#86C85D',
                        fontSize: '0.875rem',
                        cursor: 'pointer',
                        mt: 1,
                        '&:hover': {
                          textDecoration: 'underline'
                        }
                      }}
                    >
                      Forgot Password?
                    </Typography>
                  </Box>
                </Box>
              </form>
            </Box>
          </Box>
    </>

    )
};

export default Login;